import styled, { css } from 'styled-components';

import { GiftIcon, InfoIcon } from '@icons';

import { BREAKPOINTS } from '@shared/styled-system';

import bgFinished from '@assets/images/coin-race/race/bg-finished.png';
import bg from '@assets/images/coin-race/race/bg.png';

export const Container = styled.div``;

export const ContentWrapper = styled.div`
	width: 100%;
	max-width: 1240px;
	margin: 0 auto;
	padding: 0 16px;
	box-sizing: border-box;
`;

export const TopSection = styled.div<{ $isFinished?: boolean }>`
	width: 100%;
	background-image: url(${({ $isFinished }) => ($isFinished ? bgFinished : bg)});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;

	padding: 32px 0;

	@media (${BREAKPOINTS.MOBILE}) {
		padding: 24px 0;
	}
`;

export const TopSectionContent = styled(ContentWrapper)`
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media (${BREAKPOINTS.MOBILE}) {
		flex-direction: column;
		align-items: center;
	}
`;

export const LeftBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;

	@media (${BREAKPOINTS.TABLET}) {
		width: 100%;
		align-items: center;
		text-align: center;
	}

	@media (${BREAKPOINTS.MOBILE}) {
		width: 100%;
		align-items: center;
		text-align: center;
	}
`;

export const RightBlock = styled.div`
	display: flex;
	justify-content: center;
	align-items: flex-start;

	@media (${BREAKPOINTS.TABLET}) {
		display: none;
	}

	@media (${BREAKPOINTS.MOBILE}) {
		display: none;
	}
`;

export const CupImage = styled.img`
	width: 100%;
	max-width: 510px;
	aspect-ratio: auto;
	height: 240px;
	object-fit: contain;
`;

export const MobileJackpotWrapper = styled.div`
	display: none;

	@media (${BREAKPOINTS.TABLET}) {
		display: flex;
		justify-content: center;
		width: 100%;
	}

	@media (${BREAKPOINTS.MOBILE}) {
		display: flex;
		justify-content: center;
		width: 100%;
	}

	& > div {
		max-width: 100%;
	}
`;

export const MobileCupImage = styled.img`
	display: none;
	width: 100%;
	max-width: 340px; /* или как у вас было */
	margin: 24px auto;

	@media (${BREAKPOINTS.TABLET}) {
		display: block;
	}
	@media (${BREAKPOINTS.MOBILE}) {
		display: block;
	}
`;

export const MetaInfo = styled.div`
	display: flex;
	gap: 24px;
	flex-wrap: wrap;

	@media (${BREAKPOINTS.MOBILE}) {
		gap: 12px;
		justify-content: center;
	}
`;

export const MetaItem = styled.div<{ $iconColor?: string }>`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 16px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	font-weight: 500;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ $iconColor, theme }) => $iconColor || theme.colors.text.alwaysWhite};
	}
`;

export const Duration = styled.span`
	font-size: 16px;
	color: ${({ theme }) => theme.colors.text.subtitle};
	font-weight: 400;

	span {
		color: ${({ theme }) => theme.colors.text.alwaysWhite};
		font-weight: 500;
	}
`;

export const Jackpot = styled.span`
	font-size: 18px;
	font-weight: 500;
	line-height: 22px;

	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	text-transform: capitalize;
`;

export const RaceName = styled.h1`
	font-size: 28px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin: 0;

	@media (${BREAKPOINTS.MOBILE}) {
		font-size: 24px;
	}
`;

export const Description = styled.p`
	font-size: 16px;
	color: ${({ theme }) => theme.colors.text.body};
	line-height: 1.6;

	margin: 0;
`;

export const Actions = styled.div`
	display: flex;
	gap: 16px;
	margin-top: 16px;

	@media (${BREAKPOINTS.MOBILE}) {
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
		gap: 12px;
	}
`;

export const LeaveButtonContent = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 6px;

	svg {
		width: 16px;
		height: 16px;
		fill: currentColor;
	}
`;

export const Section = styled.div`
	margin-top: 32px;
`;

export const RefreshLeaderboard = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
	margin-bottom: 32px;
`;

export const SectionTitle = styled.h2`
	font-size: 28px;
	font-weight: 700;
	text-transform: capitalize;
	color: ${({ theme }) => theme.colors.text.title};
	margin: 0 0 24px 0;
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const UserBadge = styled.span`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 500;
`;

export const PrizeCard = styled.div<{ $isClickable?: boolean }>`
	position: relative;

	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 12px;
	padding: 12px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;

	${({ $isClickable }) =>
		$isClickable &&
		css`
			cursor: pointer;
		`}
`;

export const PrizeInfoIcon = styled(InfoIcon)`
	position: absolute;
	top: 8px;
	right: 8px;

	width: 16px;
	height: 16px;
	fill: ${({ theme }) => theme.colors.icon.main};
`;

export const PrizeInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const PrizeDetailsButtonWrapper = styled.div`
	margin-top: 8px;
	display: inline-flex;
	width: fit-content;
`;

export const PrizePosition = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const PrizeValue = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;

	margin-top: 8px;

	svg {
		fill: ${({ theme }) => theme.colors.icon.main};

		margin-left: 4px;

		vertical-align: middle;
		display: inline-block;
		margin-bottom: 2px;
	}
`;

export const GiftIconStyled = styled(GiftIcon)`
	width: 16px;
	height: 16px;

	path {
		fill: #6c00e7;
	}
`;

export const PrizeImageBlock = styled.div`
	width: 50px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}
`;

export const PrizeImagePlaceholder = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.colors.text.subtitle};
	text-align: center;
	padding: 0 8px;
`;

export const LeaderBoardTitle = styled.h3`
	font-weight: 700;
	font-size: 28px;
	line-height: 34px;
	letter-spacing: 0px;
	margin: 0 0 20px 0;

	color: ${({ theme }) => theme.colors.text.title};
`;

export const LeaderboardTable = styled.div`
	border-radius: 8px;
	padding-bottom: 8px;
	overflow: hidden;
`;

export const TableHeader = styled.div`
	display: grid;
	grid-template-columns: 0.5fr 2fr 1fr 1fr;
	padding: 16px;
	background: linear-gradient(90deg, #262126 0%, #391b37 100%);
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const TableRow = styled.div<{ $isCurrentUser?: boolean }>`
	display: grid;
	grid-template-columns: 0.5fr 2fr 1fr 1fr;
	padding: 12px 16px;
	font-size: 14px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-top: 6px;

	${({ $isCurrentUser, theme }) =>
		$isCurrentUser &&
		css`
			border: 1px solid ${theme.colors.transparent.light30};
		`}

	&:nth-child(odd) {
		background-color: transparent;
	}

	&:nth-child(even) {
		background-color: ${({ theme }) => theme.colors.background.secondary};
	}
`;

export const TableCell = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: 100%;
	gap: 6px;
	overflow: hidden;

	svg {
		fill: ${({ theme }) => theme.colors.icon.chevron};
	}
`;

export const TextEllipsis = styled.span<{ $isMe?: boolean }>`
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100%;
	text-align: center;
	color: ${({ theme, $isMe }) => $isMe && theme.colors.text.link};
`;

export const HeaderText = styled.span`
	@media (${BREAKPOINTS.MOBILE}) {
		display: none;
	}
`;

export const EmptyMessage = styled.div`
	text-align: center;
	padding: 48px 20px;
	font-size: 16px;
	color: ${({ theme }) => theme.colors.text.body};
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 8px;
`;

export const StatusBadge = styled.div`
	padding: 4px 6px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 500;
	text-transform: capitalize;
	color: ${({ theme }) => theme.colors.icon.warning};
	background-color: rgba(251, 174, 39, 0.1);
`;
